import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Login from './pages/Login';

import Dashboard from './pages/Dashboard';
import ChurnRisk from './pages/models/ChurnRisk';
import RevenueForecast from './pages/models/RevenueForecast';
import TierMigration from './pages/models/TierMigration';
import CampaignResponse from './pages/models/CampaignResponse';
import DeclinerDetection from './pages/models/DeclinerDetection';
import RisingStar from './pages/models/RisingStar';
import NearHarvest from './pages/models/NearHarvest';
import VIPLikely from './pages/models/VIPLikely';
import CLV from './pages/models/CLV';
import BasketRecommendation from './pages/models/BasketRecommendation';
import UpsellRecommendation from './pages/models/UpsellRecommendation';
import CrossSellRecommendation from './pages/models/CrossSellRecommendation';
import ReplenishmentPredictor from './pages/models/ReplenishmentPredictor';
import TestAndLearn from './pages/TestAndLearn';
import DataManager from './pages/DataManager';
import Settings from './pages/Settings';

export default function App() {
  const [authed, setAuthed] = useState(() => !!localStorage.getItem('demo_auth'));

  if (!authed) {
    return <Login onAuth={() => setAuthed(true)} />;
  }

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Dashboard />} />

        {/* Core Models */}
        <Route path="/models/churn-risk" element={<ChurnRisk />} />
        <Route path="/models/revenue-forecast" element={<RevenueForecast />} />
        <Route path="/models/tier-migration" element={<TierMigration />} />
        <Route path="/models/campaign-response" element={<CampaignResponse />} />

        {/* Customer Scoring */}
        <Route path="/models/decliner-detection" element={<DeclinerDetection />} />
        <Route path="/models/rising-star" element={<RisingStar />} />
        <Route path="/models/near-harvest" element={<NearHarvest />} />
        <Route path="/models/vip-likely" element={<VIPLikely />} />
        <Route path="/models/clv" element={<CLV />} />

        {/* Basket & Product Intelligence */}
        <Route path="/models/basket-recommendation" element={<BasketRecommendation />} />
        <Route path="/models/upsell-recommendation" element={<UpsellRecommendation />} />
        <Route path="/models/cross-sell-recommendation" element={<CrossSellRecommendation />} />
        <Route path="/models/replenishment-predictor" element={<ReplenishmentPredictor />} />

        <Route path="/test-learn" element={<TestAndLearn />} />
        <Route path="/data-manager" element={<DataManager />} />
        <Route path="/settings" element={<Settings />} />
      </Route>
    </Routes>
  );
}
